import { Snackbar, Alert, Slide } from "@mui/material";
import { AxiosError } from "axios";
import { DefaultError } from "@tanstack/react-query";
import React from "react";

type ErrorSnackbarProps = {
  open: boolean;
  onClose: () => void;
  error: DefaultError | null | undefined;
};

const SlideUp = (props: any) => <Slide {...props} direction="up" />;

export default function ErrorSnackbar({ open,  onClose, error }: ErrorSnackbarProps) {
  //@ts-ignore
  const message = error?.response?.data?.message;
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      TransitionComponent={SlideUp}
    >
      <Alert onClose={onClose} severity="error" sx={{ width: "100%", textAlign: "center" }}>
        Error: {error?.message}
        <br />
        {message}
      </Alert>
    </Snackbar>
  );
}
